"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccordionWidgetToolbarButtons = void 0;
var react_1 = __importDefault(require("react"));
var AccordionToolbar_1 = __importDefault(require("./AccordionToolbar"));
var inversify_react_1 = require("inversify-react");
var WidgetManager_1 = require("Project/QwilrEditor/WidgetManager");
var EditorTypes_1 = require("Project/QwilrEditor/EditorTypes");
var AccordionRegistryContext_1 = require("./AccordionRegistryContext");
var AccordionWidgetToolbarButtons = function (_a) {
    var element = _a.element;
    var blockStore = (0, inversify_react_1.useInjection)("blockStore");
    var brandStore = (0, inversify_react_1.useInjection)("brandStore");
    var telemetry = (0, inversify_react_1.useInjection)("editorTelemetry");
    var widgetManager = (0, inversify_react_1.useInjection)(WidgetManager_1.WidgetManager);
    var onClickClone = function () {
        var data = {
            action: "clone",
            path: widgetManager.getPath(element),
        };
        widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("accordion", data));
    };
    var onVisualAccordionSelected = function () {
        widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("accordion", { action: EditorTypes_1.AccordionActionType.EnsureVisualAccordionImages }));
    };
    var usingVisualAccordion = true;
    var stylePermissionStore = (0, inversify_react_1.useInjection)("stylePermissionStore");
    var widgetRef = (0, AccordionRegistryContext_1.useAccordionRegistryContext)().widgetRef;
    return (react_1.default.createElement(AccordionToolbar_1.default, { blockStore: blockStore, brandStore: brandStore, onClickClone: onClickClone, usingVisualAccordion: usingVisualAccordion, onVisualAccordionSelected: onVisualAccordionSelected, telemetry: telemetry, stylePermissionStore: stylePermissionStore, widgetRef: widgetRef }));
};
exports.AccordionWidgetToolbarButtons = AccordionWidgetToolbarButtons;
